import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ColoAllocationComponent } from './colo-allocation/colo-allocation.component';
import { PointToPointConnectivityPreviewComponent } from './point-to-point-connectivity-preview/point-to-point-connectivity-preview.component';
import { ColoRackSetupComponent } from './colo-rack-setup/colo-rack-setup.component';
import { ColoRequestListComponent } from './colo-request-list/colo-request-list.component';
import { ColoRequestModalComponent } from './colo-request-modal/colo-request-modal.component';
import { PointToPointConnectivityComponent } from './point-to-point-connectivity/point-to-point-connectivity.component';
import { PointToPointConnectivityAdminComponent } from './point-to-point-connectivity-admin/point-to-point-connectivity-admin.component';
import { AddColoRackComponent } from './add-colo-rack/add-colo-rack.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpModule } from '../otp.module';

@NgModule({
  declarations: [AddColoRackComponent, ColoAllocationComponent , ColoRackSetupComponent,ColoRequestListComponent,ColoRequestModalComponent,PointToPointConnectivityComponent,
    PointToPointConnectivityAdminComponent,PointToPointConnectivityPreviewComponent] ,
  imports: [
    CommonModule,
    SharedModule,
    OtpModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule],
  
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class ColoModule { }
